import { ApiClient } from "@/utils/apiClient";
import type { User } from "@/models/user";
import type { ApiResponse } from "@/models/api";
import type { Membership } from "@/models/membership";

export type UserMeResponse = ApiResponse<{
  user: User;
  membership: Membership;
  lotteryTicketNumbers: string[];
}>;

export type UserUpdatePayload = {
  address?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  countryCode?: string;
  phone?: string;
  newsletter?: boolean;
  firstName?: string;
  lastName?: string;
}

export type UserUpdateEmailPayload = {
  email: string;
  password: string;
  newEmail: string;
  newEmailConfirmation: string;
}

export type UserUpdatePasswordPayload = {
  password: string;
  newPassword: string;
  newPasswordConfirmation: string;
}

export abstract class UserApiService {
  // NOTE We can only operate on currently logged in user
  public static async get(): Promise<UserMeResponse> {
    const response = await ApiClient.getClient().get<UserMeResponse>('/users/me');
    return response.data;
  }
  public static async update(user: UserUpdatePayload): Promise<UserMeResponse> {
    const response = await ApiClient.getClient().patch<UserMeResponse>('/users/me', user);
    return response.data;
  }
  public static async updateEmail(payload: UserUpdateEmailPayload): Promise<UserMeResponse> {
    const response = await ApiClient.getClient().patch<UserMeResponse>('/users/me/email', payload);
    return response.data;
  }

  public static async updatePassword(payload: UserUpdatePasswordPayload): Promise<UserMeResponse> {
    const response = await ApiClient.getClient().patch<UserMeResponse>('/users/me/password', payload);
    return response.data;
  }
}
